<template>
  <div class="newsDetail">
    <div class="container">
      <div class="title">
        <h3>{{newsDetail.title}}</h3>
      </div>
      <div class="info">
        <span>Source from: {{newsDetail.student}}</span> <span> {{newsDetail.updated_at}} </span> <span>{{newsDetail.hits}} Reads </span>
      </div>
      <van-divider />
      <div v-html="newsDetail.content"
           class="cont-detail"></div>
      <van-divider>End</van-divider>
      <div class="botBar">
        <a :href="(newsDetail.prev.id ? ('/mobile/news-detail/'+newsDetail.prev.id):'javascript:;')"> <span>Prev :</span> <i>{{newsDetail.prev.title ? newsDetail.prev.title:'No more'}}</i></a>

        <a :href="(newsDetail.next.id ? ('/mobile/news-detail/'+newsDetail.next.id):'javascript:;')"> <span>Next :</span> <i>{{newsDetail.next.title ? newsDetail.next.title:'No more'}}</i></a>
      </div>
    </div>

  </div>
</template>

<script>
import axiosApi from "../api/api.js";

export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      newsDetail: {
        next: '',
        prev: '',
      },
    }
  },
  mounted () {
    console.log(this.$route.params.id)
    axiosApi(
      'newsinfo/' + this.$route.params.id, {}, 'get'
    ).then((res) => {
      this.newsDetail = res.data
    })
  },
  methods: {

  }
}
</script>


<style lang="scss" scoped>
.container {
  padding: 25px;
  .title {
    h3 {
      font-size: 36px;
      margin-bottom: 40px;
      word-break: break-all;
      text-align: center;
    }
  }
  .info {
    display: flex;
    justify-content: center;
    span {
      margin-right: 20px;
      color: #545454;
    }
  }
  .botBar {
    a {
      display: flex;
      color: #f29810;
      span {
        width: 80px;
        color: #263e65;
      }
      i {
        width: calc(100% - 80px);
        font-style: normal;
      }
    }
  }
}
</style>
<style lang="scss">
.cont-detail {
  font-size: 28px;
  img {
    width: 100% !important;
    height: auto !important;
  }
  word-break: break-all;
}
</style>
